import { AxiosResponse } from "axios"
import { useQuery } from "react-query"
import { toast } from "react-toastify"

import reportService from "api/reportService"
import { IGetReportQueryParams } from "types/report"

export interface IUseGetReportProps {
  query: IGetReportQueryParams
  enabled: boolean
}

const useGetReport = ({ query, enabled }: IUseGetReportProps) => {
  return useQuery(['report'], async () => {
    const res: AxiosResponse<any> =  await reportService.getReport(query)

    return res.data
  }, { 
      enabled, 
      retry: false, 
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      onError: (err) => {
        toast.error("Internal Server Error")
      }
    })
}

export default useGetReport